import clsx from 'clsx';
import { EvaluationSummary } from '../types/stats';

interface EvaluationTabsProps {
  evaluations: EvaluationSummary[];
  selected: string | null;
  onSelect: (value: string) => void;
}

export const EvaluationTabs = ({ evaluations, selected, onSelect }: EvaluationTabsProps) => {
  if (evaluations.length === 0) {
    return null;
  }

  return (
    <div className="flex flex-wrap gap-3">
      {evaluations.map((evaluation) => {
        const isActive = evaluation.evaluation === selected;
        return (
          <button
            key={evaluation.evaluation}
            type="button"
            onClick={() => onSelect(evaluation.evaluation)}
            className={clsx(
              'rounded-full border px-3 py-1 text-xs font-semibold uppercase tracking-widest transition',
              isActive
                ? 'border-hero-red-20 bg-hero-red-10 text-readable-red'
                : 'border-[#E2E5EA] bg-white text-blueprint-blue hover:border-[#C0C5CE]',
            )}
          >
            {evaluation.evaluation}
          </button>
        );
      })}
    </div>
  );
};
